<template>
  <div>
    <!-- PopUp of confirmation deleted:start -->
    <AlertMessage ref="alertDeletedMessage" id_alert="deleted-confirmation-alert" class="dark" />
    <!-- PopUp of confirmation deleted:end -->

    <!-- PopUp of confirmation change status:start -->
    <AlertMessage ref="alertChangeStatusMessage" id_alert="status-change-confirmation-alert" class="dark" />
    <!-- PopUp of confirmation change status:end -->

    <!-- PopUp of confirmation continue miniGuide:start -->
    <AlertMessage ref="alertContinueMiniguide" id_alert="continue-mini-guide-alert" class="dark" />
    <!-- PopUp of confirmation continue miniGuide:end -->

    <!-- Confirmation-Edit:start -->
    <Message id="save-mini-guide-success" :text="$t(`${viewRoot}.update`)" />
    <!-- Confirmation-Edit:end -->

    <!-- Confirmation-Saved:start -->
    <Message :id="messages.savedTempSuccessId" :text="$t(`${viewRoot}.save_temp`)" />
    <!-- Confirmation-Saved:end -->

    <!-- Confirmation-Delete:start -->
    <Message :id="messages.removedSuccessId" :text="$t(`${viewRoot}.delete`)" />
    <!-- Confirmation-Delete:end -->

    <div id="validation-error-mini-guide" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t(`${viewRoot}.validation_error.title`) }}</div>
        <div class="text-gray-600 mt-1">{{ $t(`${viewRoot}.validation_error.subtitle`) }}</div>
      </div>
    </div>
    <!-- Confirmation-Delete:end -->

    <!-- Title-and-Name:start -->
    <div class="intro-y mt-8">
      <h2 class="text-lg font-medium mr-auto">
        {{ $t(`${viewRoot}.title`) }}<template v-if="miniGuide.id">: {{ langs_inputs[activeLangKey].name }}</template>
      </h2>
    </div>
    <!-- Title-and-Name:end -->

    <!-- Loader:start-->
    <div v-if="initialLoading" class="intro-y w-full h-full flex justify-center items-center">
      <div class="wrapper__loading">
        <LoadingIcon icon="tail-spin" />
      </div>
    </div>
    <!-- Loader:end-->

    <!-- Main content:start -->
    <div v-else class="flex flex-row mt-5 mb-12 w-full gap-4">
      <div class="w-full">
        <!-- Tabs-Languages:start -->
        <div class="lang__tabs nav nav-tabs intro-y flex-col sm:flex-row text-gray-600 rounded-b-none" role="tablist">
          <a
            v-for="(lang, key) in langs"
            :key="key"
            data-toggle="tab"
            @click="changeLang('lang__' + lang.key)"
            :id="'lang__' + lang.key + '-tab'"
            role="tab"
            :data-target="'#lang__' + lang.key"
            href="javascript:;"
            class="tooltip w-full sm:w-40 py-4 text-center flex justify-center items-center rounded-t-md"
            :class="{
              'active border-transparent': activeLang === 'lang__' + lang.key,
              'border border-theme-6 rounded-md': langValidations[lang.key] && activeLang !== 'lang__' + lang.key, // Solo aplica el borde rojo si no es la pestaña activa
            }"
            :aria-controls="'lang__' + lang.key"
            aria-selected="false"
          >
            {{ $t("components.langs." + lang.key + ".name") }}
            <!-- Icono de exclamación para indicar error si lo deseas -->
            <span v-if="langValidations[lang.key]" class="ml-2 text-red-500 font-bold text-lg">!</span>
          </a>
        </div>
        <!-- Tabs-Languages:end -->

        <!-- Form:start  -->
        <div v-for="(lang, key) in langs" :key="key" :class="'post__lang__' + lang.key" class="tab-content">
          <div
            :id="'lang__' + lang.key"
            class="tab-pane"
            :class="activeLang === 'lang__' + lang.key ? 'active' : ''"
            role="tabpanel"
            :aria-labelledby="'lang__' + lang.key + '-tab'"
          >
            <div class="intro-y col-span-12 lg:col-span-6">
              <div class="intro-y box p-5">
                <!-- TITLE -->
                <div class="intro-y mb-8 mt-3">
                  <h2 class="text-md font-medium mr-auto">
                    {{ $t("globals.structure.segmentation_data") }}
                  </h2>
                </div>

                <!-- Category & Subcategory -->
                <div class="flex gap-4 mt-2">
                  <!-- Categoría -->
                  <div class="w-1/3">
                    <label class="form-label">{{ $t(`${viewRoot}.form.category.label`) }}</label>
                    <div
                      class="input-group input-bg-theme-32 rounded relative"
                      :class="validations.category && 'border border-theme-6'"
                    >
                      <!-- Placeholder visual -->
                      <span
                        v-if="!miniGuide.mini_guide_category_id || miniGuide.mini_guide_category_id === '0'"
                        class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                      >
                        {{ $t(`${viewRoot}.form.category.placeholder`) }}
                      </span>
                      <TomSelect
                        :disabled="isReadOnly"
                        ref="category"
                        class="w-full cursor"
                        v-model="miniGuide.mini_guide_category_id"
                        :placeholder="$t(`${viewRoot}.form.category.placeholder`)"
                      >
                        <option v-for="c in categories" :key="c.id" :value="c.id" :label="c.name">
                          {{ c.name }}
                        </option>
                      </TomSelect>
                    </div>
                    <div v-if="validations.category" class="text-theme-6 mt-2">
                      {{ $t(`${viewRoot}.form.category.validation`) }}
                    </div>
                  </div>

                  <!-- Subcategoría -->
                  <div class="w-1/3">
                    <label class="form-label">{{ $t(`${viewRoot}.form.subcategory.label`) }}</label>
                    <div
                      class="input-group input-bg-theme-32 rounded relative"
                      :class="validations.subcategory && 'border border-theme-6'"
                    >
                      <!-- Placeholder visual -->
                      <span
                        v-if="!miniGuide.mini_guide_subcategory_id || miniGuide.mini_guide_subcategory_id === '0'"
                        class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                      >
                        {{ $t(`${viewRoot}.form.subcategory.placeholder`) }}
                      </span>

                      <TomSelect
                        :disabled="isReadOnly"
                        ref="subcategory"
                        class="w-full cursor"
                        v-model="miniGuide.mini_guide_subcategory_id"
                        :placeholder="$t(`${viewRoot}.form.subcategory.placeholder`)"
                      >
                        <option v-for="c in subcategories" :key="c.id" :value="c.id" :label="c.name">
                          {{ c.name }}
                        </option>
                      </TomSelect>
                    </div>
                    <div v-if="validations.subcategory" class="text-theme-6 mt-2">
                      {{ $t(`${viewRoot}.form.subcategory.validation`) }}
                    </div>
                  </div>

                  <!-- SEXO BIOLÓGICO -->
                  <div class="w-1/3">
                    <label class="form-label">{{ $t(`${viewRoot}.form.biological_sex.label`) }}</label>
                    <div
                      class="input-group input-bg-theme-32 rounded"
                      :class="validations.biological_sex && 'border border-theme-6'"
                    >
                      <TomSelect
                        ref="biological_sex"
                        :disabled="isReadOnly"
                        v-model="miniGuide.biological_sex"
                        :input_hide="true"
                        class="w-full cursor"
                        :placeholder="$t(`${viewRoot}.form.biological_sex.placeholder`)"
                      >
                        <option
                          v-for="(key, idx) in biologicalSexKeys"
                          :key="`biological_sex-${idx}`"
                          :value="key"
                          :label="`biological_sex-${idx}`"
                        >
                          {{ $t(`globals.biological_sex.${key}`) }}
                        </option>
                      </TomSelect>
                    </div>
                    <div v-if="validations.biological_sex" class="text-theme-6 mt-2">
                      {{ $t(`${viewRoot}.form.biological_sex.validation`) }}
                    </div>
                  </div>
                </div>

                <!-- Grupo etario objetivo - Age Range -->
                <div class="mt-9 mb-9">
                  <AgeRangesSelect
                    v-model="miniGuide.age_ranges"
                    :label="$t(`${viewRoot}.form.target_age_group.label`)"
                    :error="validations.targetAgeGroups ? $t(`${viewRoot}.form.target_age_group.validation`) : ''"
                  />
                </div>

                <!-- Multi (hormonal, deficits) -->
                <div class="flex flex-row w-full mt-8 gap-4">
                  <!--HORMONAL IMBALANCES-->
                  <div class="w-1/2">
                    <label class="form-label">{{ $t(`${viewRoot}.form.associated_hormonal_imbalance.label`) }}</label>
                    <div class="input-group input-bg-theme-32 rounded relative">
                      <!-- Placeholder visual -->
                      <span
                        v-if="!miniGuide.hormonal_imbalances || miniGuide.hormonal_imbalances.length === 0"
                        class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                      >
                        {{ $t(`${viewRoot}.form.associated_nutritional_deficiency.placeholder`) }}
                      </span>

                      <TomSelect
                        :disabled="isReadOnly"
                        ref="associated_hormonal_imbalance"
                        class="w-full cursor"
                        v-model="miniGuide.hormonal_imbalances"
                        :placeholder="$t(`${viewRoot}.form.associated_hormonal_imbalance.placeholder`)"
                        :plugins="['remove_button', 'dropdown_input']"
                        :multiple="true"
                      >
                        <option v-for="key in hormonalImbalancesKeys" :key="key" :value="key">
                          {{ $t(`globals.hormonal_imbalances.${key}`) }}
                        </option>
                      </TomSelect>
                    </div>
                  </div>

                  <!--NUTRITIONAL DEFICIT-->
                  <div class="w-1/2">
                    <label class="form-label">
                      {{ $t(`${viewRoot}.form.associated_nutritional_deficiency.label`) }}
                    </label>
                    <div class="input-group input-bg-theme-32 rounded relative">
                      <!-- Placeholder visual -->
                      <span
                        v-if="!miniGuide.nutritional_deficits || miniGuide.nutritional_deficits.length === 0"
                        class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                      >
                        {{ $t(`${viewRoot}.form.associated_nutritional_deficiency.placeholder`) }}
                      </span>

                      <TomSelect
                        :disabled="isReadOnly"
                        ref="associated_nutritional_deficiency"
                        class="w-full cursor"
                        v-model="miniGuide.nutritional_deficits"
                        :placeholder="$t(`${viewRoot}.form.associated_nutritional_deficiency.placeholder`)"
                        :plugins="['remove_button', 'dropdown_input']"
                        :multiple="true"
                      >
                        <option
                          v-for="nutritionalDeficit in nutritionalDeficits"
                          :key="nutritionalDeficit.id"
                          :value="nutritionalDeficit.id"
                        >
                          {{ nutritionalDeficit.name }}
                        </option>
                      </TomSelect>
                    </div>
                  </div>
                </div>

                <!-- Digestive disorders -->
                <div class="w-full mt-3">
                  <label class="form-label">
                    {{ $t(`${viewRoot}.form.digestive_disorders.label`) }}
                  </label>
                  <div class="input-group input-bg-theme-32 rounded relative">
                    <!-- Placeholder visual -->
                    <span
                      v-if="!miniGuide.digestives_disorders || miniGuide.digestives_disorders.length === 0"
                      class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                    >
                      {{ $t(`${viewRoot}.form.digestive_disorders.placeholder`) }}
                    </span>

                    <TomSelect
                      :disabled="isReadOnly"
                      ref="digestive_disorders"
                      class="w-full cursor"
                      v-model="miniGuide.digestives_disorders"
                      :plugins="['remove_button', 'dropdown_input']"
                      :multiple="true"
                    >
                      <option v-for="disorder in digestiveDisorders" :key="disorder.id" :value="disorder.id">
                        {{ disorder.name }}
                      </option>
                    </TomSelect>
                  </div>
                </div>

                <!--BAD HABITS-->
                <div class="w-full mt-3">
                  <label for="crud-form-3" class="form-label">
                    {{ $t(`${viewRoot}.form.bad_habit_detected.label`) }}
                  </label>
                  <div
                    class="input-group input-bg-theme-32 rounded relative"
                    :class="validations.badHabits && 'border border-theme-6'"
                  >
                    <!-- Placeholder visual -->
                    <span
                      v-if="!miniGuide.bad_habits || miniGuide.bad_habits.length === 0"
                      class="absolute left-3 top-2 text-gray-600 text-sm pointer-events-none"
                    >
                      {{ $t(`${viewRoot}.form.bad_habit_detected.placeholder`) }}
                    </span>

                    <TomSelect
                      :disabled="isReadOnly"
                      ref="bad_habit_detected"
                      class="w-full cursor"
                      v-model="miniGuide.bad_habits"
                      :category="true"
                      :plugins="['remove_button', 'dropdown_input']"
                      :multiple="true"
                    >
                      <optgroup v-for="(badHabitGroup, key) in badHabits" :key="key" :label="badHabitGroup.category">
                        <option
                          v-for="(badHabit, key) in badHabitGroup.habits"
                          :key="key"
                          :data-cat="badHabit.name"
                          :value="badHabit.id"
                        >
                          –
                          {{ badHabit.name }}
                        </option>
                      </optgroup>
                    </TomSelect>
                  </div>
                </div>
              </div>

              <hr class="my-10" />

              <!-- TITLE -->
              <div class="intro-y mb-7 mt-10">
                <h2 class="text-md font-medium mr-auto">{{ $t("globals.structure.title_text") }}</h2>
              </div>

              <div class="flex gap-3 items-center justify-center">
                <!--Título técnico para sistema (por idioma) -->
                <div class="flex-1">
                  <label class="form-label">{{ $t(`${viewRoot}.form.technical_title.name`) }}</label>
                  <input
                    type="text"
                    class="form-control w-full bg-theme-32"
                    :class="[
                      (validations.technical_title || hasForbidden('technical_title')) && 'border border-theme-6',
                    ]"
                    v-model="langs_inputs[lang.key].technical_title"
                    maxlength="110"
                    :placeholder="$t(`${viewRoot}.form.technical_title.placeholder`)"
                    @input="checkForbidden('technical_title', langs_inputs[lang.key].technical_title)"
                  />

                  <div v-if="validations.technical_title" class="text-theme-6 mt-2">
                    {{ $t(`${viewRoot}.form.technical_title.validation`) }}
                  </div>
                  <div v-if="hasForbidden('technical_title')" class="text-theme-6 mt-2">
                    {{ $t("views.forbidden") }}
                    <strong>{{ getForbidden("technical_title").join(", ") }}</strong>
                  </div>
                </div>

                <!-- checkbox solo miniguias de apertura -->
                <div class="flex items-center mx-1 mt-6">
                  <p class="mr-3">{{ $t(`${viewRoot}.form.opening`) }}</p>
                  <input type="checkbox" class="form-check-switch" v-model="miniGuide.opening" />
                </div>
              </div>
              <!-- White / Blue title -->
              <div class="mt-6">
                <div class="intro-y mb-7 mt-10">
                  <h2 class="text-md font-medium mr-auto">{{ $t(`${viewRoot}.form.title_for_app`) }}</h2>
                </div>
                <div class="flex gap-4">
                  <!-- WHITE -->
                  <div class="w-1/2">
                    <label class="form-label">{{ $t(`${viewRoot}.form.white_title.name`) }}</label>
                    <input
                      type="text"
                      class="form-control w-full bg-theme-32"
                      :class="[(validations.white_title || hasForbidden('white_title')) && 'border border-theme-6']"
                      v-model="langs_inputs[lang.key].white_title"
                      maxlength="25"
                      :placeholder="$t(`${viewRoot}.form.white_title.placeholder`)"
                      @input="checkForbidden('white_title', langs_inputs[lang.key].white_title)"
                    />

                    <!-- contador -->
                    <div
                      class="text-xs mt-1 whitespace-nowrap"
                      :class="
                        langs_inputs[lang.key].white_title?.length >= 5 &&
                        langs_inputs[lang.key].white_title?.length <= 25
                          ? 'text-green-500'
                          : 'text-red-500 font-semibold'
                      "
                    >
                      {{ langs_inputs[lang.key].white_title?.length || 0 }}/25
                    </div>

                    <div v-if="validations.white_title" class="text-theme-6 mt-2">
                      {{ $t(`${viewRoot}.form.white_title.validation`) }}
                    </div>
                    <div v-if="hasForbidden('white_title')" class="text-theme-6 mt-2">
                      {{ $t("views.forbidden") }}
                      <strong>{{ getForbidden("white_title").join(", ") }}</strong>
                    </div>
                  </div>

                  <!-- BLUE -->
                  <div class="w-1/2">
                    <label class="form-label">{{ $t(`${viewRoot}.form.blue_title.name`) }}</label>
                    <input
                      type="text"
                      class="form-control w-full bg-theme-32"
                      :class="[(validations.blue_title || hasForbidden('blue_title')) && 'border border-theme-6']"
                      v-model="langs_inputs[lang.key].blue_title"
                      maxlength="13"
                      :placeholder="$t(`${viewRoot}.form.blue_title.placeholder`)"
                      @input="checkForbidden('blue_title', langs_inputs[lang.key].blue_title)"
                    />

                    <!-- contador -->
                    <div
                      class="text-xs mt-1 whitespace-nowrap"
                      :class="
                        langs_inputs[lang.key].blue_title?.length >= 5 &&
                        langs_inputs[lang.key].blue_title?.length <= 13
                          ? 'text-green-500'
                          : 'text-red-500 font-semibold'
                      "
                    >
                      {{ langs_inputs[lang.key].blue_title?.length || 0 }}/13
                    </div>

                    <div v-if="validations.blue_title" class="text-theme-6 mt-2">
                      {{ $t(`${viewRoot}.form.blue_title.validation`) }}
                    </div>
                    <div v-if="hasForbidden('blue_title')" class="text-theme-6 mt-2">
                      {{ $t("views.forbidden") }}
                      <strong>{{ getForbidden("blue_title").join(", ") }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <!--Subtitle Copete-->
              <div class="w-full">
                <label class="form-label mt-6">{{ $t(`${viewRoot}.form.subtitle.name`) }}</label>
                <input
                  type="text"
                  class="form-control w-full bg-theme-32"
                  :class="[(validations.subtitle || hasForbidden('subtitle')) && 'border border-theme-6']"
                  v-model="langs_inputs[lang.key].subtitle"
                  maxlength="110"
                  :placeholder="$t(`${viewRoot}.form.subtitle.placeholder`)"
                  @input="checkForbidden('subtitle', langs_inputs[lang.key].subtitle)"
                />

                <!-- contador -->
                <div
                  class="text-xs mt-1 whitespace-nowrap"
                  :class="
                    langs_inputs[lang.key].subtitle?.length >= 5 && langs_inputs[lang.key].subtitle?.length <= 90
                      ? 'text-green-500'
                      : 'text-red-500 font-semibold'
                  "
                >
                  {{ langs_inputs[lang.key].subtitle?.length || 0 }}/90
                </div>

                <div v-if="validations.subtitle" class="text-theme-6 mt-2">
                  {{ $t(`${viewRoot}.form.subtitle.validation`) }}
                </div>
                <div v-if="hasForbidden('subtitle')" class="text-theme-6 mt-2">
                  {{ $t("views.forbidden") }}
                  <strong>{{ getForbidden("subtitle").join(", ") }}</strong>
                </div>
              </div>

              <hr class="my-10" />

              <!-- CUERPO DE LA MINI-GUIA -->
              <div class="intro-y mb-7 mt-10">
                <h2 class="text-md font-medium mr-auto">{{ $t("globals.structure.text2") }}</h2>
              </div>

              <!-- PARAGRAPHS -->
              <div class="mt-3">
                <label class="form-label">{{ $t("globals.structure.text3") }}</label>

                <div class="input-group w-full">
                  <input
                    id="crud-form-1"
                    type="text"
                    class="form-control"
                    :class="[(validations.paragraphs || hasForbidden('paragraphs')) && 'border border-theme-6']"
                    :placeholder="$t('globals.structure.text3')"
                    aria-describedby="input-group-price"
                    v-model="paragraph_inputs[lang_key].input"
                    @input="checkForbidden('paragraphs', paragraph_inputs[lang_key].input)"
                    @keyup="addParagraph($event)"
                    @focusout="addParagraph($event)"
                  />

                  <div
                    id="input-group-price"
                    class="input-group-text btn"
                    :class="[
                      { 'opacity-50 cursor-not-allowed pointer-events-none': isMax },
                      itemCount >= 9 && !isMax ? 'text-green-500' : '',
                    ]"
                    @click="addParagraph('click')"
                  >
                    <PlusIcon />
                  </div>
                </div>

                <!-- mensaje de error por palabra prohibida -->
                <div v-if="hasForbidden('paragraphs')" class="text-theme-6 mt-2">
                  {{ $t("views.forbidden") }}
                  <strong>{{ getForbidden("paragraphs").join(", ") }}</strong>
                </div>

                <div class="text-xs mt-1 whitespace-nowrap" :class="counterClass">{{ itemCount }}/{{ MAX_ITEMS }}</div>

                <div
                  v-if="paragraph_inputs[lang_key].input"
                  class="mt-2 text-xs"
                  :class="
                    countWords(paragraph_inputs[lang_key].input) <= MAX_OPTIMAL_WORDS_PARAGRAPH
                      ? 'text-gray-400'
                      : countWords(paragraph_inputs[lang_key].input) > MAX_WORDS_PARAGRAPH
                        ? 'text-red-500'
                        : 'text-yellow-500'
                  "
                >
                  {{ $t("views.miniguides.write") }} {{ countWords(paragraph_inputs[lang_key].input) }}
                  {{ $t("views.miniguides.max_write", { max: MAX_OPTIMAL_WORDS_PARAGRAPH }) }}
                </div>

                <div v-if="validations.paragraphs" class="text-theme-6 mt-2">
                  {{ $t("globals.structure.items_range_paragraphs", { min: MIN_ITEMS, max: MAX_ITEMS }) }}
                </div>

                <div v-if="validations.paragraphsLength" class="text-theme-6 mt-2">
                  {{ validations.paragraphsLength }}
                </div>

                <div class="mt-5" v-if="paragraph_inputs[lang_key].items.length > 0">
                  <div class="flex items-center" v-for="(val, key) in paragraph_inputs[lang_key].items" :key="key">
                    <div class="items-center w-full relative" v-if="!val.edit">
                      <div class="intro-x">
                        <div class="box border px-5 py-4 mb-3 flex flex-col">
                          <div class="flex items-center">
                            <div class="ml-4 mr-auto">
                              <div class="font-medium">{{ val.text }}</div>
                            </div>
                            <button
                              @click="editPragraph(val, true)"
                              type="button"
                              class="ml-5 btn-outline-dark btn-rounded btn-sm"
                            >
                              <EditIcon class="btn-source-icon" />
                            </button>
                            <button
                              @click="deleteParagraph(val)"
                              type="button"
                              class="btn-outline-dark btn-rounded btn-sm"
                            >
                              <Trash2Icon class="btn-source-icon" />
                            </button>
                          </div>
                          <div
                            class="text-xs mt-2 ml-4"
                            :class="
                              countWords(val.text) <= MAX_OPTIMAL_WORDS_PARAGRAPH
                                ? 'text-gray-400'
                                : countWords(val.text) > MAX_WORDS_PARAGRAPH
                                  ? 'text-red-500'
                                  : 'text-yellow-500'
                            "
                          >
                            {{ $t("views.miniguides.paragraph_text") }} {{ key + 1 }}) — {{ countWords(val.text) }}
                            {{ $t("views.miniguides.paragraph_words", { max: MAX_OPTIMAL_WORDS_PARAGRAPH }) }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="block w-full" v-else>
                      <div class="input-group w-full mb-3">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('views.supplements.text42')"
                          aria-describedby="input-group-price"
                          v-model="val.text"
                        />
                        <div id="input-group-price" class="input-group-text btn" @click="editPragraph(val, false)">
                          <SaveIcon />
                        </div>
                      </div>
                      <div
                        class="text-xs mt-2"
                        :class="
                          countWords(val.text) <= MAX_OPTIMAL_WORDS_PARAGRAPH
                            ? 'text-gray-400'
                            : countWords(val.text) > MAX_WORDS_PARAGRAPH
                              ? 'text-red-500'
                              : 'text-yellow-500'
                        "
                      >
                        {{ $t("views.miniguides.paragraph_text") }} {{ key + 1 }}) — {{ countWords(val.text) }}
                        {{ $t("views.miniguides.paragraph_words", { max: MAX_OPTIMAL_WORDS_PARAGRAPH }) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Frase al final -->
              <div class="mt-6">
                <label class="form-label">{{ $t(`${viewRoot}.text_final`) }}</label>
                <input
                  type="text"
                  class="form-control w-full bg-theme-32"
                  :class="[(validations.closing_phrase || hasForbidden('closing_phrase')) && 'border border-theme-6']"
                  :placeholder="$t(`${viewRoot}.text_final`)"
                  v-model="langs_inputs[lang.key].closing_phrase"
                  maxlength="110"
                  @input="checkForbidden('closing_phrase', langs_inputs[lang.key].closing_phrase)"
                />
                <div v-if="validations.closing_phrase" class="text-theme-6 mt-2">
                  {{ $t(`${viewRoot}.text_final`) }}
                </div>
                <div v-if="hasForbidden('closing_phrase')" class="text-theme-6 mt-2">
                  {{ $t("views.forbidden") }}
                  <strong>{{ getForbidden("closing_phrase").join(", ") }}</strong>
                </div>
              </div>

              <!-- TERMS GLOSSARY MINI-GUIDE - Listado de palabras complejas -->
              <div class="mt-6">
                <label class="form-label">{{ $t(`${viewRoot}.form.terms.validation`) }}</label>

                <div class="input-group w-full">
                  <input
                    id="glossary-input"
                    type="text"
                    class="form-control"
                    :class="validations.terms && 'border border-theme-6'"
                    :placeholder="$t('views.miniguides.form.terms.placeholder')"
                    aria-describedby="glossary-add-btn"
                    v-model="glossary_inputs[lang_key].input"
                    @keyup="addGlossaryItem($event)"
                    @focusout="addGlossaryItem($event)"
                    maxlength="100"
                  />

                  <div
                    id="glossary-add-btn"
                    class="input-group-text btn"
                    :class="[
                      { 'opacity-50 cursor-not-allowed pointer-events-none': glossaryIsMax },
                      glossaryCount >= 9 && !glossaryIsMax ? 'text-gray-500' : '',
                    ]"
                    @click="addGlossaryItem('click')"
                  >
                    <PlusIcon />
                  </div>
                </div>

                <!-- contador  -->
                <div
                  class="text-xs mt-2 whitespace-nowrap"
                  :class="
                    glossary_inputs[lang_key].input?.length > 100 ? 'text-red-500 font-semibold' : 'text-gray-500'
                  "
                >
                  {{ glossary_inputs[lang_key].input?.length || 0 }}/100
                </div>

                <!-- listado de términos -->
                <div class="mt-5" v-if="glossary_inputs[lang_key].items.length > 0">
                  <div class="flex items-center" v-for="(val, key) in glossary_inputs[lang_key].items" :key="key">
                    <div class="items-center w-full relative" v-if="!val.edit">
                      <div class="intro-x">
                        <div class="box border px-5 mb-3 flex items-center">
                          <div class="ml-4 mr-auto">
                            <div class="font-medium">{{ val.text }}</div>
                          </div>
                          <button
                            @click="editGlossaryItem(val, true)"
                            type="button"
                            class="ml-5 btn-outline-dark btn-rounded btn-sm"
                          >
                            <EditIcon class="btn-source-icon" />
                          </button>
                          <button
                            @click="deleteGlossaryItem(val)"
                            type="button"
                            class="btn-outline-dark btn-rounded btn-sm"
                          >
                            <Trash2Icon class="btn-source-icon" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- modo edición -->
                    <div class="block w-full" v-else>
                      <div class="input-group w-full mb-3">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('views.glossary.text15') || 'Término'"
                          aria-describedby="glossary-save-btn"
                          v-model="val.text"
                          maxlength="100"
                        />
                        <div id="glossary-save-btn" class="input-group-text btn" @click="editGlossaryItem(val, false)">
                          <SaveIcon />
                        </div>
                      </div>

                      <!-- contador -->
                      <div
                        class="text-xs mt-1 whitespace-nowrap"
                        :class="val.text?.length > 100 ? 'text-red-500 font-semibold' : 'text-green-500'"
                      >
                        {{ val.text?.length || 0 }}/100
                      </div>
                    </div>
                  </div>
                </div>

                <!-- mensaje de validación -->
                <div v-if="validations.terms" class="text-theme-6 mt-2">
                  {{ $t(`${viewRoot}.form.terms.validation`) }}
                </div>
              </div>

              <!-- Tags field:start -->
              <SearchItemsList
                class="mt-3"
                v-model="miniGuide.tags"
                :items="tagsList"
                :label="$t(`${viewRoot}.form.tags.label`)"
                :placeholder="$t(`${viewRoot}.form.tags.placeholder`)"
                :error="validations.tags ? $t(`${viewRoot}.form.tags.validation`) : ''"
              />
              <!-- Tags field:end -->

              <!-- notas de programacion -->
              <div class="mt-6">
                <label for="crud-form-3" class="form-label">
                  {{ $t("views.miniguides.form.programming_notes.label") }}
                </label>
                <div class="input-group" :class="validations.programming_notes && 'border border-theme-6'">
                  <textarea
                    id="crud-form-3"
                    class="form-control"
                    rows="6"
                    v-model="miniGuide.programming_notes"
                    maxlength="971"
                  ></textarea>
                </div>
                <div v-if="validations.programming_notes" class="text-theme-6 mt-2">
                  {{ $t("views.miniguides.form.programming_notes.validation") }}
                </div>
              </div>

              <!-- Resource links:start -->
              <MultipleTextList
                v-model="miniGuide.resource_links"
                class="mt-6"
                item-key="link"
                :label="$t(`${viewRoot}.form.resource_links.label`)"
                :placeholder="$t('views.supplements.text42') + ': https://www.medicalresearch.com/sources/evidence.pdf'"
                :editErrorText="$t(`${viewRoot}.form.resource_links.validation`)"
                :isURL="true"
              />
              <!-- Resource links:end -->

              <hr class="my-10" />

              <!-- TITLE Advertising content based on the mini guide -->
              <div class="intro-y mb-7 mt-10">
                <h2 class="text-md font-medium mr-auto">{{ $t("globals.structure.advertising_content") }}</h2>
              </div>
              <!-- Versión corta para redes sociales (1 párrafo, por idioma) -->
              <div class="mt-6">
                <label class="form-label">
                  {{ $t("views.miniguides.social_media_title") || "Versión corta para redes sociales (1 párrafo)" }}
                </label>
                <div class="input-group">
                  <textarea
                    class="form-control"
                    rows="4"
                    :class="[
                      (validations.social_media_content_social_summary ||
                        hasForbidden('social_media_content_social_summary')) &&
                        'border border-theme-6',
                    ]"
                    :placeholder="$t('views.miniguides.social_media_title') || 'Escribe un solo párrafo breve...'"
                    v-model="langs_inputs[lang.key].social_media_content_social_summary"
                    maxlength="250"
                    @input="
                      checkForbidden(
                        'social_media_content_social_summary',
                        langs_inputs[lang.key].social_media_content_social_summary
                      )
                    "
                  >
                  </textarea>
                </div>

                <!-- contador  -->
                <div
                  class="text-xs mt-2 whitespace-nowrap"
                  :class="
                    langs_inputs[lang.key].social_media_content_social_summary?.length > 250
                      ? 'text-red-500 font-semibold'
                      : 'text-gray-500'
                  "
                >
                  {{ langs_inputs[lang.key].social_media_content_social_summary?.length || 0 }}/250
                </div>

                <div v-if="validations.social_media_content_social_summary" class="text-theme-6 mt-2">
                  {{ $t("views.miniguides.social_media_title") || "Este campo es obligatorio" }}
                </div>
                <div v-if="hasForbidden('social_media_content_social_summary')" class="text-theme-6 mt-2">
                  {{ $t("views.forbidden") }}
                  <strong>{{ getForbidden("social_media_content_social_summary").join(", ") }}</strong>
                </div>
              </div>

              <!-- Frase disparadora o pregunta para engagement (por idioma) -->
              <div class="mt-6 mb-9">
                <label class="form-label">
                  {{ $t("views.miniguides.social_media_phrase") || "Frase disparadora / pregunta" }}
                </label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control w-full bg-theme-32"
                    :class="[
                      (validations.social_media_content_network_trigger ||
                        hasForbidden('social_media_content_network_trigger')) &&
                        'border border-theme-6',
                    ]"
                    :placeholder="$t('views.miniguides.social_media_phrase') || '¿Qué opinás sobre…?'"
                    v-model="langs_inputs[lang.key].social_media_content_network_trigger"
                    maxlength="140"
                    @input="
                      checkForbidden(
                        'social_media_content_network_trigger',
                        langs_inputs[lang.key].social_media_content_network_trigger
                      )
                    "
                  />
                </div>
                <div v-if="validations.social_media_content_network_trigger" class="text-theme-6 mt-2">
                  {{ $t("views.miniguides.social_media_phrase") || "Este campo es obligatorio" }}
                </div>
                <div v-if="hasForbidden('social_media_content_network_trigger')" class="text-theme-6 mt-2">
                  {{ $t("views.forbidden") }}
                  <strong>{{ getForbidden("social_media_content_network_trigger").join(", ") }}</strong>
                </div>
              </div>
            </div>
          </div>
          <!-- Fields-Form:end  -->
        </div>

        <hr class="my-10" />

        <!-- Question with answers:module:start -->
        <div class="intro-y col-span-12 lg:col-span-6 mt-6">
          <!-- TITLE -->
          <div class="intro-y mb-8 mt-3">
            <h2 class="text-md font-medium mr-auto">ILONGAME</h2>
          </div>

          <QuestionWithAnswersModule
            v-for="(q, i) in questions"
            :key="q.id ?? i"
            :model-value="q"
            :langs="langs"
            :active-lang-key="activeLangKey"
            :forbidden-terms-props="forbiddenTerms"
            :disabled-level-difficulty="true"
            :read-only="false"
            @update:modelValue="(val) => updateQuestion(i, val)"
          />
        </div>
        <!-- Question with answers:module:end -->

        <hr class="my-10" />

        <!-- Alert:module:start -->
        <div class="intro-y col-span-12 lg:col-span-6 mt-6">
          <!-- TITLE -->
          <div class="intro-y mb-6 mt-3">
            <h2 class="text-md font-medium mr-auto">
              {{ editModeAlert ? $t(`${viewRoot}.titles.edit_alert`) : $t(`${viewRoot}.titles.alerts`) }}
            </h2>
          </div>

          <!-- SELECTOR Option New Alert or Select Existing Alert -->
          <div v-if="!editModeAlert" class="mb-6">
            <div class="flex gap-4">
              <div class="form-check mr-2">
                <input
                  id="alert-option-new"
                  class="form-check-input"
                  type="radio"
                  name="alert-option"
                  v-model="alertOption"
                  :value="alertOptionsAvailable.new"
                />
                <label class="form-check-label" for="alert-option-new">
                  {{ $t(`${viewRootAlert}.new`) }}
                </label>
              </div>
              <div class="form-check">
                <input
                  id="alert-option-existing"
                  class="form-check-input"
                  type="radio"
                  name="alert-option"
                  v-model="alertOption"
                  :value="alertOptionsAvailable.existing"
                />
                <label class="form-check-label" for="alert-option-existing">
                  {{ $t(`${viewRootAlert}.select_existing_alert`) }}
                </label>
              </div>
            </div>
          </div>

          <!--SELECT ALERT MINI-GUIDE-->
          <template v-if="alertOption === alertOptionsAvailable.existing">
            <!-- Si no hay alertas (paginationAlert.total es 0) -->
            <div v-if="paginationAlert.total === 0" class="intro-y col-span-12 box py-10 mt-5">
              <div class="text-center">
                <h2 class="text-lg font-medium text-gray-700 dark:text-gray-300">
                  {{ $t(`${viewRootAlert}.noAlertsAvailable`) }}
                </h2>
              </div>
            </div>

            <!-- SINO (v-else): Si sí hay alertas (paginationAlert.total es mayor que 0) -->
            <div v-else class="grid grid-cols-12 gap-6 mb-12">
              <!-- Error message for alert selection:start -->
              <div v-if="validations.alertSelectedId" class="col-span-12">
                <div class="toastify-content border-theme-6 flex alert-error-visual">
                  <XCircleIcon class="text-theme-6" />
                  <div class="ml-4 mr-4">
                    <div class="font-medium">
                      {{ $t(`${viewRootAlert}.select_alert_validation`) }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- Error message for alert selection:end -->

              <!--Header:start-->
              <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
                <p class="mr-auto">{{ $t(`${viewRootAlert}.description`) }}</p>
              </div>
              <!--Header:end-->

              <!-- Filters:start -->
              <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
                <div
                  class="w-full grid sm:grid-cols-2 lg:grid-cols-6 xl:grid-cols-4 gap-6 mt-3 sm:mt-0 sm:ml-auto md:ml-0"
                >
                  <!--Campo buscador-->
                  <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
                    <div class="w-full relative lg:col-span-2 xl:col-span-1 text-gray-700 dark:text-gray-300">
                      <input
                        type="text"
                        class="form-control w-full box pr-10 placeholder-theme-13"
                        :placeholder="$t(`${viewRootAlert}.search_text`)"
                        v-model="searchInputAlert"
                        @keyup="filterAlerts"
                      />
                      <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
                    </div>
                  </div>
                </div>
                <!-- Filters:end -->
              </div>

              <!-- Data-List:start -->
              <div
                class="intro-y col-span-12 overflow-auto"
                :class="{ 'border border-theme-6 rounded-md p-2': validations.alertSelectedId }"
              >
                <table class="table table-report -mt-2 overflow-hidden">
                  <thead>
                    <tr>
                      <th class="whitespace-nowrap">
                        <div class="grid alerts__grid">
                          <div class="title__table__alerts">ID</div>
                          <div class="title__table__alerts">{{ $t(`${viewRootAlert}.table.title1`) }}</div>
                          <div class="title__table__alerts">{{ $t(`${viewRootAlert}.table.title5`) }}</div>
                        </div>
                      </th>

                      <th class="text-center whitespace-nowrap w-20">
                        {{ $t(`${viewRootAlert}.table.actions`) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(alert, alertKey) in alerts" :key="alertKey">
                      <tr class="intro-x">
                        <!-- Section-Actions:end -->
                        <td :class="{ 'opacity-50': alertSelectedId !== alert.id }" @click="selectAlertId(alert.id)">
                          <div class="grid alerts__grid cursor-pointer">
                            <!--ID Alert-->
                            <div>{{ alert.id }}</div>

                            <!--Title-->
                            <div>{{ alert.title }}</div>

                            <!--Subtitle-->
                            <div>{{ alert.subtitle }}</div>
                          </div>
                        </td>

                        <!-- Section-Actions:start -->
                        <td :class="{ 'opacity-50': alertSelectedId !== alert.id }">
                          <div class="form-check d-flex justify-center items-center">
                            <input
                              :id="`alert-${alertKey}`"
                              type="checkbox"
                              class="form-check-input"
                              :checked="alertSelectedId === alert.id"
                              @change="selectAlertId(alert.id)"
                            />
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <!-- Data-List:start -->
            </div>
          </template>

          <!--FORM CREATE ALERT IN MINI-GUIDE-->
          <div v-if="alertOption === alertOptionsAvailable.new">
            <!-- TITLE -->
            <div class="intro-y mb-6">
              <h2 class="text-md font-medium mr-auto">{{ $t("views.miniguides.alert_miniguide") }}</h2>
            </div>
            <AlertsModule
              v-model="alert"
              :langs="langs"
              :active-lang-key="activeLangKey"
              :tagsList="tagsList"
              :read-only="false"
              :showBiologicalSex="false"
              :showAgeRange="false"
              :showStatus="false"
              :showHormonalImbalances="false"
              :showDigestiveDisorders="false"
              :showActionType="false"
              defaultActionType="MINI_GUIDE"
              :showNutritionalDeficiency="false"
            />
          </div>
        </div>
        <!-- Alert:module:end -->

        <hr class="my-10" />

        <!-- Botones -->
        <div class="mt-5">
          <!-- Estado -->
          <div class="season mt-8">
            <label class="form-label">{{ $t(`${viewRoot}.form.status.label`) }}</label>

            <div class="mt-2 gap-4 gap-x-6 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 xl:gap-x-6 xxl:grid-cols-6">
              <div class="form-check mr-2 mt-2 sm:mt-0">
                <input
                  id="status-approved"
                  class="form-check-input"
                  type="radio"
                  name="miniguide-status"
                  v-model="miniGuide.status"
                  value="APPROVED"
                />
                <label class="form-check-label" for="status-approved">
                  {{ getTranslationStatus("APPROVED") }}
                </label>
              </div>

              <div class="form-check mr-2 mt-2 sm:mt-0">
                <input
                  id="status-rejected"
                  class="form-check-input"
                  type="radio"
                  name="miniguide-status"
                  v-model="miniGuide.status"
                  value="REJECTED"
                />
                <label class="form-check-label" for="status-rejected">
                  {{ getTranslationStatus("REJECTED") }}
                </label>
              </div>

              <div class="form-check mr-2 mt-2 sm:mt-0">
                <input
                  id="status-pending"
                  class="form-check-input"
                  type="radio"
                  name="miniguide-status"
                  v-model="miniGuide.status"
                  value="PENDING_APPROVAL"
                />
                <label class="form-check-label" for="status-pending">
                  {{ getTranslationStatus("PENDING_APPROVAL") }}
                </label>
              </div>
            </div>

            <div v-if="validations.status" class="text-theme-6 mt-2">
              {{ $t(`${viewRoot}.form.status.validation`) }}
            </div>
          </div>
          <div class="text-right">
            <button
              v-if="miniGuide.id"
              @click="confirmRemoveMiniGuide"
              type="button"
              class="btn btn-outline-dark w-24 mr-5"
            >
              <LoadingIcon v-if="removeLoading" icon="three-dots" />
              <span v-else>{{ $t("views.delete") }}</span>
            </button>
            <button v-else @click="saveTempMiniGuide" type="button" class="btn btn-outline-dark w-36 mr-5">
              <LoadingIcon v-if="loading" icon="three-dots" />
              <span v-else>{{ $t("views.save_temp") }}</span>
            </button>
            <button @click="saveMiniGuide" type="button" class="btn btn-primary w-24">
              <LoadingIcon v-if="loading" icon="three-dots" />
              <span v-else>{{ $t("views.save") }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- Form:end  -->
    </div>
    <!-- Main content:end -->
  </div>
</template>

<script>
import Toastify from "toastify-js";
import _ from "lodash";

import AlertMessage from "@/components/alert/Main.vue";
import Message from "@/components/message/Message.vue";
import SearchItemsList from "@/components/search-items-list/Main.vue";
import QuestionWithAnswersModule from "@/views/ilongame/questionWithAnswers/Module.vue";
import AgeRangesSelect from "@/components/age-ranges-select/Main.vue";
import MultipleTextList from "@/components/multiple-text-list/Main.vue";

import AlertsModule from "@/views/alerts/Module.vue";

import MiniGuidesService from "../../services/mini_guide.service";
import MiniGuidesLocalService from "@/services/local/mini-guides.local.service";
import IlongameService from "../../services/ilongame.service";
import DeficitNutritionalService from "../../services/nutritional-deficit.service";
import DigestiveDisordersService from "../../services/digestive-disorder.service";
import HabitService from "../../services/habit.service";
import TagService from "../../services/tag.service";
import AlertsService from "../../services/alerts.service";

import { checkForbidden, hasForbidden, getForbidden } from "@/utils/forbidden_terms";
import * as QuestionWithAnswersUtils from "@/utils/modules/ilongame/questionWithAnswers";
import * as AlertsUtils from "@/utils/modules/alerts";

export default {
  name: "Miniguide",
  components: {
    AlertMessage,
    Message,
    SearchItemsList,
    QuestionWithAnswersModule,
    AlertsModule,
    AgeRangesSelect,
    MultipleTextList,
  },
  data() {
    return {
      viewRoot: "views.miniguides",
      viewRootAlert: "views.alerts",
      // UI
      messages: {
        savedSuccessId: "saved-confirmation-success",
        savedTempSuccessId: "saved-temp-confirmation-success",
        updatedSuccessId: "updated-confirmation-success",
        removedSuccessId: "removed-confirmation-success",
      },
      // Constants
      MAX_OPTIMAL_WORDS_PARAGRAPH: 29,
      MAX_WORDS_PARAGRAPH: 50,

      miniGuide: {
        id: null,
        mini_guide_category_id: "0",
        mini_guide_subcategory_id: "0",
        biological_sex: "BOTH",
        ai_generated_content: false,
        is_promotional: false,
        programming_notes: "",
        status: "PENDING_APPROVAL",
        originalStatus: "PENDING_APPROVAL",
        forbidden_term_ids: [],
        social_media_content: { langs: [] },
        langs: [],
        paragraphData: [],
        hormonal_imbalances: [],
        nutritional_deficits: [],
        digestives_disorders: [],
        bad_habits: [],
        terms: [],
        age_ranges: [],
        tags: [],
        opening: false,

        // Fields for resource links
        currentLinksResource: "",
        resource_links: [],
      },
      validations: {
        category: false,
        subcategory: false,
        biological_sex: false,
        status: false,
        technical_title: false,
        white_title: false,
        blue_title: false,
        subtitle: false,
        closing_phrase: false,
        social_media_content_social_summary: false,
        social_media_content_network_trigger: false,
        programming_notes: false,
        targetAgeGroups: false,
        forbiddenTerms: false,
        badHabits: false,
        terms: false,
        age_ranges: false,
        paragraphs: false,
        paragraphsLength: "",
        tags: false,
        alertSelectedId: false,
      },
      forbiddenTerms: [],
      FORBIDDEN_CACHE_KEY: "forbidden_terms_v1",
      FORBIDDEN_CACHE_TTL_MS: 1000 * 60 * 30,
      forbidden: {},
      langValidations: {},
      langs_inputs: {},
      paragraph_inputs: {},
      glossary_inputs: {},
      langs: this.$global.getLangs(),
      ageGroupKeys: this.$global.getAgesRanges(),
      hormonalImbalancesKeys: this.$global.getHormonalImbalances(),
      biologicalSexKeys: this.$global.getGenders(),
      categories: [],
      subcategories: [],
      nutritionalDeficits: [],
      digestiveDisorders: [],
      badHabits: [],

      // Lists
      tagsList: [],

      loading: false,
      removeLoading: false,
      isReadOnly: false,
      lang_key: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      GLOSSARY_MAX: 30,
      MIN_ITEMS: 6,
      MAX_ITEMS: 12,
      activeLangKey: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      activeLang: "lang__" + (localStorage.lang ? localStorage.lang : navigator.language.split("-")[0]),
      isInitialLoadComplete: false,
      editMode: false,
      // Array of questionsWithAnswers - for each level difficulty
      difficultyLevels: [1, 2, 3, 4, 5],
      questions: [
        // Data for question with answers module
        {
          id: null,
          mini_guide_id: null,
          difficulty_level: 1,
          langs: {},
          validations: {},
          answers: [],
        },
      ],
      minAnswers: 4,

      // ALERT MODULE
      editModeAlert: false,
      alert: {
        id: null,
        mini_guide_id: null,
        langs: {
          es: { title: "", content: "" },
          en: { title: "", content: "" },
        },
        biological_sex: "BOTH",
        action_type: "MINI_GUIDE",
        hormonal_imbalances: [],
        nutritional_deficits: [],
        digestive_disorders: [],
        time_of_day: "BEDTIME",
        age_ranges: [],
        tags: [],
        status: "PENDING_APPROVAL",
        validations: {
          title: "",
          content: "",
          tags: "",
          age_ranges: "",
        },
      },
      alerts: [],

      // UI
      initialLoading: true,

      searchInputAlert: "",
      paginationAlert: {
        page: 0,
        total_pages: 0,
        per_page: 10,
        total: 0,
      },
      alertSelectedId: null,
      alertOptionsAvailable: {
        new: "NEW",
        existing: "EXISTING",
      },
      alertOption: "NEW",
      debounceTimeout: null,
    };
  },

  created() {
    this.generateInitialStructure();
  },

  mounted() {
    this.loadAllOptions();
  },

  computed: {
    itemCount() {
      const k = this.lang_key;
      return this.paragraph_inputs?.[k]?.items?.length || 0;
    },
    isMax() {
      return this.itemCount >= this.MAX_ITEMS;
    },
    counterClass() {
      return this.itemCount >= 9 ? "text-green-500 font-semibold" : "text-gray-500";
    },
    glossaryCount() {
      const k = this.lang_key;
      return this.glossary_inputs?.[k]?.items?.length || 0;
    },
    glossaryIsMax() {
      return this.glossaryCount >= this.GLOSSARY_MAX;
    },
    glossaryCounterClass() {
      return this.glossaryCount >= 9 ? "text-green-500 font-semibold" : "text-gray-500";
    },
    filteredForbiddenTerms() {
      return this.forbiddenTerms;
    },
  },
  watch: {
    "miniGuide.mini_guide_category_id": {
      handler: async function (val, oldVal) {
        // Only proceed if the initial loading process is complete AND
        // if the value has actually changed from its previous state
        // (i.e., not just being set to the same value again, or undefined initially)
        if (this.editMode === true) {
          if (!this.isInitialLoadComplete) {
            this.isInitialLoadComplete = true; // Mark initial load as complete AFTER getMiniGuide has run
            return;
          }
        }
        // Check if the value is actually different from the old value,
        // or if oldVal was '0' and val is now something else (a real selection)
        // This helps prevent re-running if an internal process re-assigns the same value.
        if (val === oldVal && (val !== "0" || oldVal !== "0")) {
          return;
        }
        // Reset subcategory unconditionally when category changes
        this.miniGuide.mini_guide_subcategory_id = "0";
        this.subcategories = []; // Clear current subcategories

        if (val && val !== "0") {
          await this.loadSubcategories(val);
        }
      },
      immediate: false, // Ensures it doesn't run when the component is first created
    },
    "miniGuide.age_ranges": {
      handler: async function (val, oldVal) {
        // Formatted Ages Ranges
        this.alert.age_ranges = val;
      },
      immediate: false,
    },
    "miniGuide.biological_sex": {
      handler: async function (val, oldVal) {
        this.alert.biological_sex = val;
      },
      immediate: false,
    },
    "miniGuide.tags": {
      handler: async function (val, oldVal) {
        this.alert.tags = [...new Set([...this.alert.tags, ...val])];
      },
      immediate: false,
    },
    "miniGuide.hormonal_imbalances": {
      handler: async function (val, oldVal) {
        this.alert.hormonal_imbalances = val;
      },
      immediate: false,
    },
    "miniGuide.nutritional_deficits": {
      handler: async function (val, oldVal) {
        this.alert.nutritional_deficits = val;
      },
      immediate: false,
    },
    "miniGuide.digestives_disorders": {
      handler: async function (val, oldVal) {
        this.alert.digestive_disorders = val;
      },
      immediate: false,
    },
    "miniGuide.status"(newVal, oldVal) {
      const originalStatus = this.miniGuide.originalStatus || "";
      if (originalStatus?.trim() === "") return;

      if (newVal !== originalStatus) {
        const styleInline = 'style="text-wrap: pretty;"';
        const originalStatusTranslated = this.getTranslationStatus(originalStatus);
        const newStatusTranslated = this.getTranslationStatus(newVal);
        const message = `
          <h2 class="text-2xl mb-5 font-bold" ${styleInline}>${this.$t(`${this.viewRoot}.message_change_status_1`)}</h2>
          <p ${styleInline}>${this.$t(`${this.viewRoot}.message_change_status_2`, {
            current: originalStatusTranslated,
            new: newStatusTranslated,
          })}</p>
        `;
        this.$refs.alertChangeStatusMessage.show(
          message,
          true,
          true,
          () => {
            // Confirm callback
            this.$refs.alertChangeStatusMessage.hide();
            this.miniGuide.originalStatus = "";
            this.miniGuide.status = newVal;
          },
          true,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          () => {
            // Cancel callback
            this.miniGuide.status = oldVal;
          }
        );
      }
    },
    alertOption: {
      handler: async function (val, oldVal) {
        if (val === this.alertOptionsAvailable.existing) {
          this.getAlerts();
          // Reset validations for new alert form
          this.alert.validations = {
            title: "",
            content: "",
            tags: "",
            age_ranges: "",
          };
        } else {
          this.alertSelectedId = null;
          this.validations.alertSelectedId = false;
          // Add tags from mini-guide to alert
          this.miniGuide.tags.forEach((tag) => {
            if (!this.alert.tags.includes(tag)) {
              this.alert.tags.push(tag);
            }
          });
        }
      },
    },
  },

  methods: {
    /**
     * * Initial Structure
     */
    generateInitialStructure() {
      const initialLangValidations = {};
      // Initialize questions with questionWithAnswers structure
      this.questions = this.generateQuestionsArray();

      // Initialize Alert structure
      this.alert = AlertsUtils.ensureShape(this.alert, this.langs);

      this.langs.forEach(({ key }) => {
        if (!this.langs_inputs[key]) {
          this.langs_inputs[key] = {
            id: null,
            technical_title: "",
            white_title: "",
            blue_title: "",
            subtitle: "",
            closing_phrase: "",
            social_media_content_social_summary: "",
            social_media_content_network_trigger: "",
          };
        }
        if (!this.paragraph_inputs[key]) this.paragraph_inputs[key] = { input: "", items: [] };
        if (!this.glossary_inputs[key]) this.glossary_inputs[key] = { input: "", items: [] };
        if (!this.forbidden[key]) this.forbidden[key] = {};
      });

      this.langValidations = initialLangValidations;
    },
    generateQuestionsArray() {
      const newQuestions = [];

      const minimalData = {
        id: null,
        mini_guide_id: null,
        difficulty_level: 1,
        langs: {},
        validations: {},
        answers: [],
      };

      this.difficultyLevels.forEach((level) => {
        minimalData.difficulty_level = level;
        newQuestions.push(
          QuestionWithAnswersUtils.ensureShape(minimalData, this.langs, { minAnswers: this.minAnswers })
        );
        newQuestions.push(
          QuestionWithAnswersUtils.ensureShape(minimalData, this.langs, { minAnswers: this.minAnswers })
        );
      });

      return newQuestions;
    },

    checkForbidden(fieldKey, value) {
      this.forbidden = checkForbidden(this.forbidden, fieldKey, value, this.forbiddenTerms);
    },
    hasForbidden(fieldKey) {
      return hasForbidden(this.forbidden, fieldKey);
    },
    getForbidden(fieldKey) {
      return getForbidden(this.forbidden, fieldKey);
    },
    /**
     * Show Toast
     */
    showToast(id) {
      Toastify({
        node: cash(`#${id}`).clone().removeClass("hidden")[0],
        duration: 3000,
        gravity: "top",
        position: "right",
        close: true,
      }).showToast();
    },
    async getMiniGuide() {
      const id = this.$route.query.id || this.miniGuide.id || false;
      this.editMode = !!id;

      if (!id) {
        // Initialize for a new mini-guide
        this.langs.forEach(({ key }) => {
          this.langs_inputs[key] = {
            technical_title: "",
            white_title: "",
            blue_title: "",
            subtitle: "",
            closing_phrase: "",
            social_media_content_social_summary: "",
            social_media_content_network_trigger: "",
          };
          this.paragraph_inputs[key] = { input: "", items: [] };
          this.glossary_inputs[key] = { input: "", items: [] };
        });

        // Get miniguide temp from local storage
        await this.getTempMiniGuide();
        return;
      }

      let miniGuideDB;
      try {
        miniGuideDB = await MiniGuidesService.getById(id, true);
        // get Questions and Answer of the Ilongame.
        const tempQuestionsFormatted = miniGuideDB.questions.map((q) =>
          QuestionWithAnswersUtils.ensureShape(QuestionWithAnswersUtils.parseFromApi(q, this.langs), this.langs, {
            minAnswers: this.minAnswers,
          })
        );
        this.questions = this.minimalCountQuestionsByLevel(tempQuestionsFormatted, 2);
      } catch (error) {
        console.error(`Error fetching MiniGuide with ID ${id}:`, error);
        // Fallback to initialization if fetch fails
        this.langs.forEach(({ key }) => {
          this.langs_inputs[key] = {
            technical_title: "",
            white_title: "",
            blue_title: "",
            subtitle: "",
            closing_phrase: "",
            social_media_content_social_summary: "",
            social_media_content_network_trigger: "",
          };
          this.paragraph_inputs[key] = { input: "", items: [] };
          this.glossary_inputs[key] = { input: "", items: [] };
        });
        return;
      }

      if (!miniGuideDB) {
        console.warn(`MiniGuide with ID ${id} not found.`);
        // Also initialize if mini-guide is not found
        this.langs.forEach(({ key }) => {
          this.langs_inputs[key] = {
            technical_title: "",
            white_title: "",
            blue_title: "",
            subtitle: "",
            closing_phrase: "",
            social_media_content_social_summary: "",
            social_media_content_network_trigger: "",
          };
          this.paragraph_inputs[key] = { input: "", items: [] };
          this.glossary_inputs[key] = { input: "", items: [] };
        });
        return;
      }

      // Deep copy to prevent direct mutations and reactivity issues
      this.miniGuide = _.cloneDeep(miniGuideDB);

      // Ensure IDs are strings for TomSelect where necessary
      this.miniGuide.mini_guide_category_id = miniGuideDB.mini_guide_category_id?.toString() || "0";
      this.miniGuide.mini_guide_subcategory_id = miniGuideDB.mini_guide_subcategory_id?.toString() || "0";
      this.miniGuide.biological_sex = miniGuideDB.biological_sex?.toString() || "0";
      // load subcategories by category mini guide
      if (this.miniGuide.mini_guide_category_id && this.miniGuide.mini_guide_category_id !== "0") {
        this.isInitialLoadComplete = false;
        await this.loadSubcategories(this.miniGuide.mini_guide_category_id);
      }

      // ** 1. Populate langs_inputs (titles, subtitles, etc.) **
      this.langs.forEach(({ key }) => {
        const langData = this.miniGuide.langs.find((l) => l.lang === key) || {};
        // Ensure social_media_content and its langs array exist before accessing
        const socialMediaData = this.miniGuide.social_media_content?.langs?.find((l) => l.lang === key) || {};

        this.langs_inputs[key] = {
          technical_title: langData.technical_title || "",
          white_title: langData.white_title || "",
          blue_title: langData.blue_title || "",
          subtitle: langData.subtitle || "",
          closing_phrase: langData.closing_phrase || "",
          social_media_content_social_summary: socialMediaData.social_summary || "",
          social_media_content_network_trigger: socialMediaData.network_trigger || "",
        };
      });

      // ** 2. Populate paragraph_inputs **
      // It's crucial that `paragraphData` elements maintain a consistent order across languages
      // or are linked by a common ID if order cannot be guaranteed.
      // Assuming `paragraphData` from the API is an ordered list of paragraph "groups"
      // where each group contains content for different languages.
      this.langs.forEach(({ key: langKey }) => {
        this.paragraph_inputs[langKey] = { input: "", items: [] }; // Reset for each language
      });

      this.miniGuide.paragraphData
        .sort((a, b) => a.order - b.order)
        .forEach((paragraphItem) => {
          this.langs.forEach(({ key: langKey }) => {
            const paragraphContent = paragraphItem.langs.find((l) => l.lang === langKey)?.content || "";
            this.paragraph_inputs[langKey].items.push({
              id: paragraphItem.id || null, // Use paragraph item's ID if available
              text: paragraphContent,
              edit: false,
              error: false,
            });
          });
        });

      // ** 3. Populate glossary_inputs (glossary terms) **
      this.langs.forEach(({ key: langKey }) => {
        this.glossary_inputs[langKey] = { input: "", items: [] }; // Reset for each language
      });

      this.miniGuide.terms.forEach((termItem) => {
        this.langs.forEach(({ key: langKey }) => {
          const termName = termItem.langs.find((l) => l.lang === langKey)?.name || "";
          this.glossary_inputs[langKey].items.push({
            id: termItem.id || null, // Use term item's ID if available
            text: termName,
            edit: false,
            error: false,
          });
        });
      });

      // ** 4. Populate other miniGuide fields that are arrays of objects or IDs **
      // Ensure hormonal_imbalances loads as an array of strings (the names)
      this.miniGuide.hormonal_imbalances = miniGuideDB.hormonal_imbalances?.map((hi) => hi.name) || [];

      // Ensure nutritional_deficits loads as an array of numerical IDs
      this.miniGuide.nutritional_deficits =
        miniGuideDB.nutritional_deficits?.map((nd) => nd.nutritional_deficit_id) || [];

      // Ensure digestives_disorders loads as an array of numerical IDs
      this.miniGuide.digestives_disorders =
        miniGuideDB.digestives_disorders?.map((dd) => dd.digestive_disorder_id) || [];

      // Ensure bad_habits loads as an array of numerical IDs
      this.miniGuide.bad_habits = miniGuideDB.bad_habits?.map((bh) => bh.bad_habit_id) || [];

      // Ensure age_ranges loads as an array of strings (the keys)
      this.miniGuide.age_ranges = miniGuideDB.age_ranges?.map((ar) => ar.age_range) || [];

      // Ensure Tags
      this.miniGuide.tags = miniGuideDB.tags?.map((tag) => tag.tag_id ?? tag.id) || [];

      // Once all data is loaded, if a category is selected, load its subcategories
      if (this.miniGuide.mini_guide_category_id && this.miniGuide.mini_guide_category_id !== "0") {
        await this.loadSubcategories(this.miniGuide.mini_guide_category_id);
      }

      // Load associated alert if exists
      if (miniGuideDB.alert) {
        this.alert = AlertsUtils.parseFromApi(miniGuideDB.alert, this.langs);
        this.editModeAlert = !!this.alert.id;
      }

      // Set original status for change tracking
      this.miniGuide.originalStatus = this.miniGuide.status || "PENDING_APPROVAL";

      // Resource Links - Ensure it's an array
      this.miniGuide.resource_links.forEach((rl) => {
        if (!rl.link) rl.link = "";
        rl.edit = false;
        rl.delete = false;
        rl.error = false;
      });
    },
    minimalCountQuestionsByLevel(questions, minCount) {
      const finalQuestions = [];

      const minimalData = {
        id: null,
        mini_guide_id: null,
        difficulty_level: 1,
        langs: {},
        validations: {},
        answers: [],
      };

      this.difficultyLevels.forEach((level) => {
        const questionsForLevel = questions.filter((q) => q.difficulty_level === level);
        const currentCount = questionsForLevel.length;

        finalQuestions.push(...questionsForLevel);
        minimalData.difficulty_level = level;
        if (currentCount < minCount) {
          const toAdd = minCount - currentCount;
          for (let i = 0; i < toAdd; i++) {
            finalQuestions.push(
              QuestionWithAnswersUtils.ensureShape(minimalData, this.langs, { minAnswers: this.minAnswers })
            );
          }
        }
      });

      return finalQuestions;
    },
    getTranslationStatus(status) {
      if (status === "APPROVED") return this.$t("views.miniguides.approved");
      if (status === "REJECTED") return this.$t("views.miniguides.disapproved");
      if (status === "PENDING_APPROVAL") return this.$t("views.miniguides.to_be_approved");
      return status;
    },
    async saveTempMiniGuide() {
      this.loading = true;

      const miniGuide = JSON.stringify(this.miniGuide);
      const langs = JSON.stringify(this.langs_inputs);
      const paragraphs = JSON.stringify(this.paragraph_inputs);
      const glossaries = JSON.stringify(this.glossary_inputs);
      const questions = JSON.stringify(this.questions);
      const alert = JSON.stringify(this.alert);

      try {
        if (this.miniGuide.id) {
          throw new Error("You cannot temporarily save a MiniGuide that has already been saved on the server.");
        }
        await MiniGuidesLocalService.saveTemp(miniGuide, langs, paragraphs, glossaries, questions, alert);
        this.showToast(this.messages.savedTempSuccessId);
      } catch (error) {
        const htmlElement =
          '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar temporalmente</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>';
        Toastify({
          node: cash(htmlElement)[0],
          duration: 3000,
          gravity: "top",
          position: "right",
          close: true,
        }).showToast();
      } finally {
        this.loading = false;
      }
    },
    async getTempMiniGuide() {
      const tempMiniGuide = await MiniGuidesLocalService.getTemp();

      if (!tempMiniGuide) return;

      const styleInline = 'style="text-wrap: pretty;"';
      const message = `
        <h2 class="text-2xl mb-5 font-bold" ${styleInline}>${this.$t(
          `${this.viewRoot}.message_continue_create_confirm_1`
        )}</h2>
        <p ${styleInline}>${this.$t(`${this.viewRoot}.message_continue_create_confirm_2`)}</p>
      `;
      let deletedData = true;
      this.$refs.alertContinueMiniguide.show(
        message,
        true,
        true,
        () => {
          // Confirm callback
          deletedData = false;

          const miniGuide = JSON.parse(tempMiniGuide.miniGuide);
          if (miniGuide) {
            miniGuide.id = null;
            this.miniGuide = miniGuide;

            const categoryId = this.miniGuide.mini_guide_category_id;
            const subcategoryId = this.miniGuide.mini_guide_subcategory_id;
            // Once all data is loaded, if a category is selected, load its subcategories
            if (categoryId && categoryId !== "0") {
              this.loadSubcategories(categoryId).then(() => {
                this.miniGuide.mini_guide_subcategory_id = subcategoryId;
              });
            }
          }

          const questions = JSON.parse(tempMiniGuide?.questions || "false");
          if (questions) this.questions = questions;

          const alert = JSON.parse(tempMiniGuide?.alert || "false");
          if (alert) this.alert = alert;

          const langs = JSON.parse(tempMiniGuide?.langs || "false");
          if (langs) this.langs_inputs = langs;

          const paragraphs = JSON.parse(tempMiniGuide?.paragraphs || "false");
          if (paragraphs) this.paragraph_inputs = paragraphs;

          const glossaries = JSON.parse(tempMiniGuide?.glossaries || "false");
          if (glossaries) this.glossary_inputs = glossaries;

          this.$refs.alertContinueMiniguide.hide();
        },
        true,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        () => {
          if (deletedData) {
            MiniGuidesLocalService.deleteTemp();
          }
        }
      );
    },
    async saveMiniGuide() {
      this.loading = true;
      let miniGuideUpsert = { ...this.miniGuide };
      // validates
      const notValid = this.validate();
      let isValidAlertNew = true;

      // Validate of the Questions Ilongame Module
      const resultsValidations = this.questions.map((qwa) =>
        QuestionWithAnswersUtils.validateQnA(qwa, this.langs, { minAnswers: this.minAnswers, t: this.$t })
      );
      const isValidQuestionsWithAnswers = resultsValidations.every(Boolean);

      // Validate Alert Module
      // if it new alert use validation alert with variable alert
      if (this.alertOption === this.alertOptionsAvailable.new) {
        isValidAlertNew = AlertsUtils.validateAlert(this.alert, this.langs, {
          requireTags: true,
          requireAgeRanges: true,
          t: this.$t,
        });
      }

      if (notValid || !isValidQuestionsWithAnswers || !isValidAlertNew) {
        this.loading = false;
        // Message indicate error validation for the user.
        Toastify({
          node: cash("#validation-error-mini-guide").clone().removeClass("hidden")[0],
          duration: 6000,
          gravity: "top",
          position: "right",
          close: true,
        }).showToast();

        // SCROLL HACIA ARRIBA:
        window.scrollTo({
          top: 0,
          behavior: "smooth", // Hace el scroll suave
        });

        return;
      }

      // Boolean if saved data
      let savedAll = true;

      // Formatted MiniGuide for save
      miniGuideUpsert = this.formatMiniGuideToSend(miniGuideUpsert);

      // Formatted Questions for save
      const newQuestionsToSave = [];
      const showErrorQuestionWithAnswers = () => {
        Toastify({
          node: cash(
            '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar IlongGame Questions</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>'
          )[0],
          duration: 3000,
          gravity: "top",
          position: "right",
          close: true,
        }).showToast();
        savedAll = false;
      };

      this.questions.forEach((qwa) => {
        // Formatted question with answers module
        const [payloadQuestionWithAnswers, editModeQuestionWithAnswers] = QuestionWithAnswersUtils.formatToSend(qwa);

        // Update question and answeer ilongame question.
        if (editModeQuestionWithAnswers) {
          IlongameService.updateQuestionWithAnswers(qwa.id, payloadQuestionWithAnswers).catch(
            showErrorQuestionWithAnswers
          );
        } else if (this.editMode && this.miniGuide.id) {
          // In edit mode, if the question is new (no ID), we need to create it
          payloadQuestionWithAnswers.mini_guide_id = this.miniGuide.id;

          IlongameService.createQuestionWithAnswers(payloadQuestionWithAnswers).catch(showErrorQuestionWithAnswers);
        } else {
          // In create mode, we will batch create all new questions after the mini-guide is created
          newQuestionsToSave.push(payloadQuestionWithAnswers);
        }
      });

      // Formatted Alert Module
      const [payloadAlert, editModeAlert] = AlertsUtils.formatToSend(this.alert);

      // Update Alert of the MiniGuide only if exist alert associated to the miniguide
      if (this.miniGuide.id) {
        payloadAlert.mini_guide_id = this.miniGuide.id; // Alert is associated with a mini-guide
      }

      // No other alert is selected from the list
      if (!miniGuideUpsert.alert_associate_id) {
        const showErrorAlert = async (error) => {
          console.error("error Update Alert", error);
          Toastify({
            node: cash(
              '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar Alert</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>'
            )[0],
            duration: 3000,
            gravity: "top",
            position: "right",
            close: true,
          }).showToast();
          savedAll = false;
        };

        // Alert is in edit mode
        if (editModeAlert) {
          AlertsService.update(this.alert.id, payloadAlert).catch(showErrorAlert);

          // If no edit mode, but miniGuide id exist, create alert associated to the miniguide
          // If no exist miniGuide id, create alert after create the miniguide
        } else if (payloadAlert.mini_guide_id) {
          AlertsService.create(payloadAlert).catch(showErrorAlert);
        }
      }

      try {
        if (this.editMode && this.miniGuide.id) {
          // Update MiniGuide
          await MiniGuidesService.update(this.miniGuide.id, miniGuideUpsert);

          Toastify({
            node: cash("#save-mini-guide-success").clone().removeClass("hidden")[0],
            duration: 3000,
            gravity: "top",
            position: "right",
            close: true,
          }).showToast();
        } else {
          // CREATE MINIGUIDE
          const response = await MiniGuidesService.create(miniGuideUpsert);

          // Delete MiniGuide temp
          await MiniGuidesLocalService.deleteTemp();

          if (!response.id) {
            savedAll = false;
            return;
          } else {
            this.miniGuide.id = response.id;
          }

          const promisesCreate = [];

          // Create Alert in MiniGuide (first promise)
          // Alert Module Associate mini_guide_id.
          const withCreateAlert = !miniGuideUpsert.alert_associate_id && !editModeAlert;
          payloadAlert.mini_guide_id = response.id;
          if (withCreateAlert) {
            promisesCreate.push(AlertsService.create(payloadAlert));
          }

          // Create IlongGame Question answers (second promise)
          // Answer Module associate mini_guide_id
          newQuestionsToSave.forEach((qwa) => {
            qwa.mini_guide_id = response.id;
            promisesCreate.push(IlongameService.createQuestionWithAnswers(qwa));
          });

          const responses = await Promise.allSettled(promisesCreate);

          if (withCreateAlert) {
            // Remove the first response (Alert) to process only Ilongame Questions if not exist alert associate id
            const alertResponse = responses.shift();

            if (alertResponse.status === "rejected") {
              console.error("error save Alert", alertResponse.reason);
              Toastify({
                node: cash(
                  '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar Alert</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>'
                )[0],
                duration: 3000,
                gravity: "top",
                position: "right",
                close: true,
              }).showToast();
              savedAll = false;
            }
          }

          responses.forEach((responseQuestionsWithAnswers, i) => {
            if (responseQuestionsWithAnswers.status === "rejected") {
              console.error("error save IlongGame Questions", responseQuestionsWithAnswers.reason);
              Toastify({
                node: cash(
                  '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar IlongGame Questions</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>'
                )[0],
                duration: 3000,
                gravity: "top",
                position: "right",
                close: true,
              }).showToast();
              savedAll = false;
            }
          });

          if (savedAll) {
            Toastify({
              node: cash("#save-mini-guide-success").clone().removeClass("hidden")[0],
              duration: 3000,
              gravity: "top",
              position: "right",
              close: true,
            }).showToast();
          }
        }
      } catch (error) {
        console.error("error save mini-guide", error);
        // Implementar un Toastify de error aquí
        Toastify({
          node: cash(
            '<div class="toastify-content flex"><XCircleIcon class="text-theme-6" /><div class="ml-4 mr-4"><div class="font-medium">Error al guardar la Mini Guía</div><div class="text-gray-600 mt-1">Inténtalo de nuevo.</div></div></div>'
          )[0],
          duration: 3000,
          gravity: "top",
          position: "right",
          close: true,
        }).showToast();
        this.isInitialLoadComplete = false;
        this.initialLoading = true;
        savedAll = false;
      } finally {
        if (savedAll) {
          this.goToList();
        } else {
          this.initialLoading = true;
          this.loading = true;
          this.isInitialLoadComplete = false;
          this.miniGuide.selectAlertId = null;
          this.alertOption = this.alertOptionsAvailable.new;

          await this.getMiniGuide();

          this.loading = false;
          this.initialLoading = false;
          this.isInitialLoadComplete = true;
        }
      }
    },
    formatMiniGuideToSend(miniGuide) {
      // Formatted Langs of the miniGuide
      miniGuide.langs = this.langs.map(({ key }) => {
        const langsInputs = this.langs_inputs[key] || {};

        return {
          lang: key,
          technical_title: langsInputs.technical_title,
          white_title: langsInputs.white_title,
          blue_title: langsInputs.blue_title,
          subtitle: langsInputs.subtitle,
          closing_phrase: langsInputs.closing_phrase,
        };
      });

      // Formatted mini_guide_category_id
      miniGuide.mini_guide_category_id = Number(this.miniGuide.mini_guide_category_id);

      // Formatted mini_guide_subcategory_id
      miniGuide.mini_guide_subcategory_id = Number(this.miniGuide.mini_guide_subcategory_id);

      // Formatted Biological Sex
      miniGuide.biological_sex = this.miniGuide.biological_sex === "0" ? null : this.miniGuide.biological_sex;

      // Formatted Langs of the Paragraphs
      miniGuide.paragraphData = Array.from(
        { length: this.paragraph_inputs[this.langs[0]?.key]?.items?.length },
        (_, index) => {
          const existingParagraph = this.miniGuide.paragraphData[index];
          const langs = this.langs.map(({ key }) => {
            const content = this.paragraph_inputs[key]?.items?.[index]?.text || "";
            return {
              lang: key,
              content: content,
            };
          });
          return {
            id: existingParagraph?.id || null,
            order: index + 1,
            langs: langs,
          };
        }
      );

      // Formatted nutritional_deficits
      miniGuide.nutritional_deficits = this.miniGuide.nutritional_deficits.map((id) => {
        return {
          nutritional_deficit_id: Number(id),
        };
      });

      // Formatted digestive_disorders
      miniGuide.digestives_disorders = this.miniGuide.digestives_disorders.map((id) => {
        return {
          digestive_disorder_id: Number(id),
        };
      });

      // Formatted bad_habits
      miniGuide.bad_habits = this.miniGuide.bad_habits.map((id) => {
        return {
          bad_habit_id: Number(id),
        };
      });

      // Formatted Tag
      miniGuide.tags = (this.miniGuide.tags || []).map((id) => ({ tag_id: id }));

      // Formatted langs of the terms glossary mini guide
      miniGuide.terms = Array.from(
        { length: this.glossary_inputs[this.langs[0]?.key]?.items?.length || 0 },
        (_, index) => {
          const existingTerm = this.miniGuide.terms[index];
          const langs = this.langs.map(({ key }) => {
            const name = this.glossary_inputs[key]?.items?.[index]?.text || "";
            return {
              lang: key,
              name: name,
            };
          });
          return {
            id: existingTerm?.id || null,
            langs,
          };
        }
      );

      // Formatted Social Media Content
      miniGuide.social_media_content = {
        id: this.miniGuide.social_media_content?.id || null,
        langs: this.langs.map(({ key }) => {
          const langsInputs = this.langs_inputs[key] || {};
          const existingSocialMediaLang = this.miniGuide.social_media_content?.langs?.find((l) => l.lang === key);
          return {
            id: existingSocialMediaLang?.id || null,
            social_summary: langsInputs.social_media_content_social_summary || "",
            network_trigger: langsInputs.social_media_content_network_trigger || "",
            lang: key,
          };
        }),
      };

      // Formatted Ages Ranges
      miniGuide.age_ranges = this.miniGuide.age_ranges.map((age) => {
        return {
          age_range: age,
        };
      });

      // Formatted disbalance hormonal
      miniGuide.hormonal_imbalances = this.miniGuide.hormonal_imbalances.map((name) => {
        return {
          name: name,
        };
      });

      // AlertId associated to the MiniGuide
      if (this.alertOption === this.alertOptionsAvailable.existing && this.alertSelectedId) {
        miniGuide.alert_associate_id = this.alertSelectedId;
      } else {
        miniGuide.alert_associate_id = null; // Clear alert association if creating a new alert or none selected
      }

      // Resource Links - Remove edit, delete, error properties
      miniGuide.resource_links = miniGuide.resource_links.filter((rl) => {
        const hasId = Boolean(rl.id);
        const link = (rl.link || "").trim();
        const notMarkedToDelete = !rl.delete;

        // If it has an ID, always keep it
        if (hasId) return true;

        // If it doesn't have an ID, keep only if it has a valid link and isn't marked for deletion
        return link !== "" && notMarkedToDelete;
      });

      return miniGuide;
    },
    goToList() {
      this.$router.push({ path: "/miniguides-list" });
    },

    /**
     * *DELETE MINI-GUIDE
     */
    confirmRemoveMiniGuide() {
      this.removeLoading = true;

      const styleInline = 'style="text-wrap: pretty;"';
      const message = `
        <h2 class="text-2xl mb-5 font-bold" ${styleInline}>${this.$t(`${this.viewRoot}.message_delete_confirm_1`)}</h2>
        <p ${styleInline}>${this.$t(`${this.viewRoot}.message_delete_confirm_2`)}</p>
      `;
      this.$refs.alertDeletedMessage.show(
        message,
        true,
        true,
        this.removeMiniGuide,
        true,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        () => {
          this.removeLoading = false;
        }
      );
    },
    removeMiniGuide() {
      const miniGuides = JSON.parse(localStorage.getItem("miniGuides")) || [];
      const found = miniGuides.find((h) => h.id === this.miniGuide.id);
      if (found) {
        const i = miniGuides.indexOf(found);
        miniGuides.splice(i, 1);
      }
      localStorage.setItem("miniGuides", JSON.stringify(miniGuides));

      Toastify({
        node: cash(`#${this.messages.removedSuccessId}`).clone().removeClass("hidden")[0],
        duration: 3000,
        gravity: "top",
        position: "right",
        close: true,
      }).showToast();

      this.goToList();
    },

    /**
     * * VALIDATES
     * Validates the mini-guide form fields based on the defined rules.
     * Updates the `this.validations` object with error states.
     * @returns {boolean} True if there are validation errors, false otherwise.
     */
    validate() {
      // Reset all validation flags before starting to clear previous errors
      for (const key in this.validations) {
        this.validations[key] = false;
      }

      this.langs.forEach(({ key }) => {
        this.langValidations[key] = false; // Asignación directa, ya que la propiedad existe
      });

      // Reset validations texts
      this.validations.paragraphsLength = "";

      let hasGlobalError = false; // Flag to track if any validation error occurs

      // 1. Validate Segmentation Data: Category, Subcategory, Biological Sex, Status, Age Ranges, Bad Habits
      // Category validation: Must not be null, undefined, or '0'
      if (!this.miniGuide.mini_guide_category_id || this.miniGuide.mini_guide_category_id === "0") {
        this.validations.category = true;
        hasGlobalError = true;
      }
      // Subcategory validation: Must not be null, undefined, or '0'
      if (!this.miniGuide.mini_guide_subcategory_id || this.miniGuide.mini_guide_subcategory_id === "0") {
        this.validations.subcategory = true;
        hasGlobalError = true;
      }
      // Biological Sex validation: Must not be null, undefined, or '0'
      if (!this.miniGuide.biological_sex || this.miniGuide.biological_sex === "0") {
        this.validations.biological_sex = true;
        hasGlobalError = true;
      }
      // Status validation: Must have a selected status other than the default/initial '0' or empty
      if (!this.miniGuide.status || this.miniGuide.status === "0") {
        this.validations.status = true;
        hasGlobalError = true;
      }
      // Target Age Groups validation: At least one age range must be selected
      if (this.miniGuide.age_ranges.length === 0) {
        this.validations.targetAgeGroups = true;
        hasGlobalError = true;
      }

      // Target Tags validation
      if (this.miniGuide.tags.length === 0) {
        this.validations.tags = true;
        hasGlobalError = true;
      }

      // 2. Validate Text Content (Titles, Subtitle, Closing Phrase) for each language
      this.langs.forEach(({ key }) => {
        const langsInputs = this.langs_inputs[key] || {}; // Get language-specific inputs
        let hasLangError = false;

        // Technical Title validation: Must not be empty
        if (!langsInputs.technical_title || langsInputs.technical_title.trim() === "") {
          this.validations.technical_title = true; // Mark global error if any language fails
          hasLangError = true;
        }
        // White Title validation: Must not be empty
        if (!langsInputs.white_title || langsInputs.white_title.trim() === "") {
          this.validations.white_title = true;
          hasLangError = true;
        }
        // Blue Title validation: Must not be empty
        if (!langsInputs.blue_title || langsInputs.blue_title.trim() === "") {
          this.validations.blue_title = true;
          hasLangError = true;
        }
        // Subtitle validation: Must not be empty
        if (!langsInputs.subtitle || langsInputs.subtitle.trim() === "") {
          this.validations.subtitle = true;
          hasLangError = true;
        }
        // Closing Phrase validation: Must not be empty
        if (!langsInputs.closing_phrase || langsInputs.closing_phrase.trim() === "") {
          this.validations.closing_phrase = true;
          hasLangError = true;
        }

        // Social Media Summary validation: Must not be empty
        if (
          !langsInputs.social_media_content_social_summary ||
          langsInputs.social_media_content_social_summary.trim() === ""
        ) {
          this.validations.social_media_content_social_summary = true;
          hasLangError = true;
        }
        // Social Media Network Trigger validation: Must not be empty
        if (
          !langsInputs.social_media_content_network_trigger ||
          langsInputs.social_media_content_network_trigger.trim() === ""
        ) {
          this.validations.social_media_content_network_trigger = true;
          hasLangError = true;
        }

        // Paragraphs validation: Check if the number of paragraphs for each language is within MIN_ITEMS and MAX_ITEMS
        const paragraphCount = this.paragraph_inputs[key]?.items?.length || 0;
        if (paragraphCount < this.MIN_ITEMS || paragraphCount > this.MAX_ITEMS) {
          this.validations.paragraphs = true; // Use a specific validation flag for paragraphs
          hasLangError = true;
        }

        //  validar palabras prohibidas en párrafos
        this.paragraph_inputs[key]?.items?.forEach((p) => {
          const forbiddenFound = this.forbiddenTerms.filter((term) =>
            p.text.toLowerCase().includes(term.toLowerCase())
          );
          if (forbiddenFound.length > 0) {
            this.validations.forbiddenTerms = true;
            hasLangError = true;
            hasGlobalError = true;
            p.error = true; // marcar visualmente ese párrafo
          }
        });
        // Marcar si este idioma tiene errores
        if (hasLangError) {
          this.langValidations[key] = true;
          hasGlobalError = true;
        }
      });

      // 3. Alert Selected Existing
      if (this.alertOption === this.alertOptionsAvailable.existing && !this.alertSelectedId) {
        this.validations.alertSelectedId = true;
        hasGlobalError = true;
      }

      // 4. Validate that the number of paragraphs is the same in all languages
      const paragraphCounts = this.langs.map(({ key }) => this.paragraph_inputs[key]?.items?.length || 0);
      const uniqueCounts = new Set(paragraphCounts);
      if (uniqueCounts.size > 1) {
        this.validations.paragraphsLength = this.$t(`${this.viewRoot}.validation_error.paragraph_length`);
        hasGlobalError = true;
      }

      // Return true if any validation error occurred, false otherwise
      return hasGlobalError;
    },

    /**
     * *LOADS DATA
     */
    async loadAllOptions() {
      await Promise.all([
        this.loadForbiddenTerms(),
        this.loadCategories(),
        this.loadDigestiveDisorders(),
        this.loadNutritionalDeficits(),
        this.loadBadHabits(),
        this.loadTags(),
      ]);

      await this.getMiniGuide();
      // this.mockData() // Remove or comment this line in production
      this.initialLoading = false;
    },
    async loadCategories() {
      try {
        const res = await MiniGuidesService.getCategories();
        this.categories = Array.isArray(res) ? res : res?.data || [];
      } catch {
        this.categories = [];
      }
    },
    async loadSubcategories(categoryId) {
      try {
        const res = await MiniGuidesService.getSubcategories(categoryId);
        this.subcategories = Array.isArray(res) ? res : res?.data || [];
      } catch (err) {
        console.error("[ERROR] No se pudieron cargar subcategorías:", err);
        this.subcategories = [];
      }
    },
    async loadNutritionalDeficits() {
      try {
        const res = await DeficitNutritionalService.getNutritionalDeficits({}, localStorage.lang);
        this.nutritionalDeficits = Array.isArray(res) ? res : res?.data || [];
      } catch {
        this.nutritionalDeficits = [];
      }
    },
    async loadDigestiveDisorders() {
      try {
        const res = await DigestiveDisordersService.getDigestiveDisorders({}, localStorage.lang);
        this.digestiveDisorders = Array.isArray(res) ? res : res?.data || [];
      } catch {
        this.digestiveDisorders = [];
      }
    },
    async loadBadHabits() {
      try {
        const res = await HabitService.getBadHabits({}, localStorage.lang);
        this.badHabits = Array.isArray(res) ? res : res?.data || [];
      } catch {
        this.badHabits = [];
      }
    },
    async loadTags() {
      try {
        const res = await TagService.getAllList(localStorage.lang);

        if (!res.success) {
          this.tagsList = [];
          return;
        }

        const formattedTag = (tag) => ({ id: tag.tag_id, name: tag.name });

        this.tagsList = (res.data?.list || []).map(formattedTag);
      } catch {
        this.tagsList = [];
      }
    },
    async loadForbiddenTerms() {
      // Si usas idiomas por término y quieres filtrar dinámicamente por pestaña activa,
      // puedes guardarlos todos y filtrar con un computed (ver abajo).

      try {
        const response = await MiniGuidesService.getForbiddenTerms();

        // Detecta si la respuesta trae directamente un array o envuelto en data
        const raw = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : [];

        this.forbiddenTerms = raw.map((term) => String(term).trim());
      } catch (error) {
        this.forbiddenTerms = [];
      }
    },
    countWords(str) {
      return str ? str.trim().split(/\s+/).length : 0;
    },

    /**
     * *PARAGRAPH
     */
    addParagraph(e) {
      const lang = this.lang_key;
      const paragraph = this.paragraph_inputs[lang];
      const text = (paragraph.input || "").trim();
      if (!text) return;
      if (paragraph.items.length >= this.MAX_ITEMS) return;

      const isEnter = e && e.type === "keyup" && e.key === "Enter";
      const isBlur = e && e.type === "focusout";
      const isClick = (e && (e.type === "click" || e.pointerId !== undefined)) || e === "click" || e?.source === "btn";

      if (isEnter || isBlur || isClick) {
        // Revision palabras prohibidas ANTES de agregar
        const forbiddenFound = this.forbiddenTerms.filter((term) => text.toLowerCase().includes(term.toLowerCase()));
        if (forbiddenFound.length > 0) {
          paragraph.error = true; // muestra el error
          return;
        }

        paragraph.items.push({ id: null, text, edit: false, error: false });
        paragraph.input = "";
        paragraph.error = false;
      }
    },

    editPragraph(val, editMode) {
      if (!editMode && (val.text || "").trim() === "") {
        val.error = true;
      } else if (!editMode) {
        const forbiddenFound = this.forbiddenTerms.filter((term) =>
          val.text.toLowerCase().includes(term.toLowerCase())
        );
        if (forbiddenFound.length > 0) {
          val.error = true;
          return;
        }

        val.error = false;
        val.edit = editMode;
      } else {
        val.edit = editMode;
        val.error = false;
      }
    },

    deleteParagraph(val) {
      const lang = this.lang_key;
      const idx = this.paragraph_inputs[lang].items.findIndex((p) => p === val);
      if (idx !== -1) {
        this.langs.forEach(({ key }) => {
          if (this.paragraph_inputs[key]?.items) {
            this.paragraph_inputs[key].items.splice(idx, 1);
          }
        });
      }
    },

    /**
     * * QuestionWithAnswers
     */
    updateQuestion(index, value) {
      this.questions[index] = value;
    },

    /**
     * *GLOSSARY
     */
    addGlossaryItem(e) {
      const lang = this.lang_key;
      const state = this.glossary_inputs[lang];
      const text = (state.input || "").trim();

      if (!text) return;
      if (state.items.length >= this.GLOSSARY_MAX) return;

      const isEnter = e && e.type === "keyup" && e.key === "Enter";
      const isBlur = e && e.type === "focusout";
      const isClick = (e && (e.type === "click" || e.pointerId !== undefined)) || e === "click" || e?.source === "btn";

      if (isEnter || isBlur || isClick) {
        // copy in the other languages
        this.langs.forEach(({ key }) => {
          if (key !== lang && !state.text) {
            this.glossary_inputs[key].items.push({
              id: null,
              text,
              edit: false,
              error: false,
            });
          }
        });

        state.items.push({ id: null, text, edit: false, error: false });
        state.input = "";
      }
    },

    editGlossaryItem(val, editMode) {
      if (!editMode && (val.text || "").trim() === "") {
        val.error = true;
      } else {
        val.edit = editMode;
        val.error = false;
      }
    },

    deleteGlossaryItem(val) {
      const lang = this.lang_key;
      const idx = this.glossary_inputs[lang].items.findIndex((p) => p === val);
      if (idx !== -1) {
        this.langs.forEach(({ key }) => {
          if (this.glossary_inputs[key]?.items) {
            this.glossary_inputs[key].items.splice(idx, 1);
          }
        });
      }
    },

    /**
     * * lANGS CONFIGs
     */
    changeLang(l) {
      this.activeLang = l;
      const k = l.replace("lang__", "");
      this.activeLangKey = k;
      this.lang_key = k;
      const fields = [
        "technical_title",
        "white_title",
        "blue_title",
        "subtitle",
        "closing_phrase",
        "social_media_content_social_summary",
        "social_media_content_network_trigger",
      ];
      fields.forEach((f) => {
        const val = this.langs_inputs[k]?.[f] || "";
        this.checkForbidden(f, k, val);
      });
    },

    /**
     * * ALERTS
     */
    async getAlerts() {
      const params = {
        search: this.searchInputAlert || "",
        action_type: "MINI_GUIDE",
        mini_guide_null: 1,
        pagination: this.paginationAlert,
      };
      const { data, pagination } = await AlertsService.getAllAlerts(params, localStorage.lang);
      this.alerts = data;
      this.paginationAlertSetData(pagination);
    },
    filterAlerts() {
      clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        this.paginationAlert.page = 0;
        this.getAlerts();
      }, 1000);
    },
    selectAlertId(alertId) {
      if (this.alertSelectedId === alertId) {
        // Si la alerta ya estaba seleccionada y se desmarca, la quitamos
        this.alertSelectedId = null;
      } else {
        // Si se selecciona una nueva alerta, la asignamos
        this.alertSelectedId = alertId;
      }
    },
    paginationAlertSetData({ page = 0, per_page: perPage = 0, total = 0, total_pages: totalPages = 0 } = {}) {
      this.paginationAlert.page = page;
      this.paginationAlert.per_page = perPage;
      this.paginationAlert.total = total;
      this.paginationAlert.total_pages = totalPages;
    },
  },
};
</script>

<style lang="scss" scoped>
// checkbox color
.dark .form-check-switch:checked {
  background-color: rgba(41, 49, 69, 1);
  border-color: rgba(63, 72, 101, 1);

  &::before {
    background-color: #c4e8fd;
  }
}

.alerts__grid {
  display: grid;
  // Default for smaller screens, adjust as needed
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  align-items: center;
  width: 100%;
  gap: 10px; // Add some gap between items

  @media screen and (min-width: 768px) {
    // Adjust breakpoint for tablets/desktops
    grid-template-columns: 0.5fr 2fr 1.5fr 1.5fr 1.5fr; // Example for 5 columns on wider screens
  }

  @media screen and (min-width: 1400px) {
    grid-template-columns: 0.5fr 3fr 1.5fr 1.5fr 1.5fr; // Further adjustment for very wide screens
  }

  .title__table,
  .content__table {
    text-wrap: wrap;
    overflow: hidden; // Ensure text doesn't overflow
    text-overflow: ellipsis; // Add ellipsis for overflowing text
  }
}
</style>
